// src/redux/reducers/phasingReducer.ts
import {
  SHOW_PHASING_PANEL,
  HIDE_PHASING_PANEL,
  TOGGLE_PHASING_NEW_WINDOW,
  SET_PHASING_NEW_WINDOW,
  SET_PHASING_TASKS
} from '../actions/phasingActions';

export interface PhasingState {
  showPhasingPanel: boolean;
  ganttDataId?: number;
  openInNewWindow: boolean;
  tasks?: any[];
}

const initialState: PhasingState = {
  showPhasingPanel: false,
  ganttDataId: undefined,
  openInNewWindow: false,
  tasks: []
};

export default function phasingReducer(
  state = initialState,
  action: any
): PhasingState {
  switch (action.type) {
    case SHOW_PHASING_PANEL:
      return { ...state, showPhasingPanel: true, ganttDataId: action.ganttDataId };
    case HIDE_PHASING_PANEL:
      return { ...state, showPhasingPanel: false, ganttDataId: undefined };
    case TOGGLE_PHASING_NEW_WINDOW:
      return { ...state, openInNewWindow: !state.openInNewWindow };
    case SET_PHASING_NEW_WINDOW:
      return { ...state, openInNewWindow: !!action.isOpen };
    case SET_PHASING_TASKS:
      return { ...state, tasks: Array.isArray(action.tasks) ? action.tasks : [] };
    default:
      return state;
  }
}
